import { useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { subscribe, getSnapshot, clearAllToasts } from "./store";
import type { ToastPosition } from "./types";
import ToastItem from "./ToastItem";
import "./toast.scss";

const MAX_VISIBLE = 5;

const POSITION_CLASSES: Record<ToastPosition, string> = {
  "top-left": "rd-toast-container--top-left",
  "top-right": "rd-toast-container--top-right",
  "bottom-left": "rd-toast-container--bottom-left",
  "bottom-right": "rd-toast-container--bottom-right",
};

export default function ToastContainer() {
  const toasts = useSyncExternalStore(subscribe, getSnapshot);

  if (toasts.length === 0) return null;

  // Group by position
  const grouped = new Map<ToastPosition, typeof toasts>();
  for (const t of toasts) {
    const list = grouped.get(t.position) ?? [];
    list.push(t);
    grouped.set(t.position, list);
  }

  return createPortal(
    <>
      {Array.from(grouped.entries()).map(([position, items]) => {
        const isBottom = position.startsWith("bottom");
        const visible = isBottom ? items.slice(-MAX_VISIBLE) : items.slice(0, MAX_VISIBLE);
        const hiddenCount = items.length - visible.length;
        const showControls = items.length > 1;

        return (
          <div key={position} className={`rd-toast-container ${POSITION_CLASSES[position]}`}>
            {showControls && (
              <div className="rd-toast-controls">
                {hiddenCount > 0 && (
                  <span className="rd-toast-controls__count">+{hiddenCount} ещё</span>
                )}
                <button
                  type="button"
                  className="rd-toast-controls__clear"
                  onClick={clearAllToasts}
                >
                  Скрыть все
                </button>
              </div>
            )}
            {visible.map((t) => (
              <ToastItem key={t.id} toast={t} />
            ))}
          </div>
        );
      })}
    </>,
    document.body,
  );
}
